<div class="panel panel-default">
    <div class="panel-heading flex flex--space-between">
        <h4 class="margin-top-0 margin-bottom-0 flex">
            <i *ngIf="currencySymbol !== 'CHF'" class="icon margin-right-8">money_notes_GBP</i>
            <small *ngIf="currencySymbol === 'CHF'" class="chf-logo margin-right-8">CHF</small>
            {{ appCopy.panelHeader['customPaymentsTitle'+selectedLanguage] }}
        </h4>
    </div>
    <div class="panel-body" *ngIf="!adminBookingDetailsLoaded">
        <div class="loader-container">
            <div class="loader">
                <svg class="circular" viewBox="25 25 50 50">
                    <circle class="path" cx="50" cy="50" r="20" />
                </svg>
            </div>
        </div>
    </div>
    <div class="panel-body" *ngIf="adminBookingDetailsLoaded">
        <p *ngIf="excessCustomsPayment === null || productType !== 2">{{ appCopy.panelHeader['noCustomPaymentsText'+selectedLanguage] }}</p>
        <div *ngIf="excessCustomsPayment !== null && productType === 2">
            <app-booking-details-customs-display 
                [appCopy]="appCopy"
                [selectedLanguage]= "selectedLanguage"
                [currencySymbol]="currencySymbol"
                [excessCustomsPayment]="excessCustomsPayment" 
                [receiptImg]="receiptImg">
            </app-booking-details-customs-display>
        </div>
        <a href="javascript:void(0);" *ngIf="excessCustomsPayment !== null && productType === 2 && excessCustomsPayment.paymentStatus !== 2"
            (click)="redirectToSettings($event, 'customs-payment')">{{ appCopy.panelHeader['takeCustomPaymentText'+selectedLanguage] }}</a>
    </div>
</div>